<template>
	<div>
		<!-- Presentation -->
		<section class="mb-5" v-if="giftcard.deliveryMethod == deliveryMethods.MAIL.id">
			<v-img src="https://res.cloudinary.com/odin-systemer/image/upload/v1575496787/resources/misc/giftcard-presentation-physical-v2.gif" aspect-ratio="1" max-width="300"></v-img>
		</section>

		<!-- Summary -->
		<section class="summary mb-12 d-sm-flex">
			<dl>
				<dt class="mobile-inline-block label-width">Til:</dt>
				<dd class="mobile-inline-block">{{ giftcard.personalMessageTo }}</dd>
				<br class="hidden-sm-and-up" />
				<dt class="mobile-inline-block label-width">Fra:</dt>
				<dd class="mobile-inline-block">{{ giftcard.personalMessageFrom }}</dd>
				<dt>Personlig melding:</dt>
				<dd>{{ giftcard.personalMessage }}</dd>
			</dl>
			<dl>
				<template v-if="giftcard.deliveryMethod == 1">
					<dt>
						Gavekortet vil bli sendt til:
						<span class="font-weight-bold">{{ giftcard.deliveryPhoneNumber }}</span>
					</dt>
					<dt>
						Leveringstidpunkt:
						<span class="font-weight-bold">{{ getMomentTime(giftcard.deliverySMSTime) }}</span>
					</dt>
				</template>
				<template v-if="giftcard.deliveryMethod == 0">
					<dt>
						Gavekortet vil bli sendt til
						<span class="font-weight-bold">{{ deliverToReceiver }}</span
						>:
					</dt>
					<dd>{{ giftcard.receiverFirstName }} {{ giftcard.receiverLastName }}</dd>
					<dd>{{ giftcard.deliveryAddress }}</dd>
					<dd>{{ giftcard.deliveryPostalCode }} {{ giftcard.deliveryPostalArea }}</dd>
				</template>
			</dl>
		</section>

		<!-- Total -->
		<section class="total mb-12">
			<dl>
				<dt>Fixit.no-gavekort</dt>
				<dd>kr {{ giftcard.amount | currency(2, 2) }}</dd>
				<dt>{{ deliveryMethod.title }}</dt>
				<dd>kr {{ deliveryMethod.priceIncVat | currency(2, 2) }}</dd>
				<dt>Totalt</dt>
				<dd class="font-weight-bold">kr {{ (parseInt(giftcard.amount) + parseInt(deliveryMethod.priceIncVat)) | currency(2, 2) }}</dd>
			</dl>
		</section>

		<!-- Terms of use -->
		<v-checkbox v-model="termsofuse" color="primary">
			<template v-slot:label>
				<div>
					Jeg har lest og akseptert
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<a target="_blank" href="/terms-of-use-portal" @click.stop v-on="on">vilkår og betingelser.</a>
						</template>
					</v-tooltip>
				</div>
			</template>
		</v-checkbox>
		<v-btn text @click="currentStep--">Tilbake</v-btn>
		<v-btn color="primary" class="ml-3" depressed @click="currentStep++" :disabled="!valid">Gå til betaling</v-btn>
	</div>
</template>

<script>
import { GiftCardPurchaseDetails } from '@/services/models';
import { DeliveryMethodEnum } from '@/services/enums/deliveryMethods';
import moment from 'moment';
export default {
	name: 'buy-giftcard-summary',
	props: {
		giftcard: GiftCardPurchaseDetails,
		value: null // Current step
	},
	data() {
		return {
			deliveryMethods: DeliveryMethodEnum,
			termsofuse: null
		};
	},
	computed: {
		valid: function() {
			return this.termsofuse;
		},
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		},
		deliveryMethod() {
			const options = this.$store.state.giftcard.deliveryOptions || [];
			const option = options.filter(o => {
				if (o.deliveryMethod == this.giftcard.deliveryMethod) {
					return o;
				}
			});
			return option.length != 0 ? option[0] : {};
		},
		deliverToReceiver() {
			if (!this.giftcard.deliveryToReceiver) {
				return 'meg';
			}
			return this.giftcard.personalMessageTo;
		}
	},
	methods: {
		async fetchDeliveryOptions() {
			this.loading++;
			await this.$store.dispatch('giftcard/getDeliveryOptions');
			this.loading--;
		},
		getMomentTime(smsTime) {
			return moment(smsTime).format('DD.MM.YYYY HH:mm') || '';
		}
	},
	created() {
		this.fetchDeliveryOptions();
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.giftcard-video {
	background-color: #dcd6dd;
	font-size: 1.5rem;
	font-weight: 700;
}

.summary {
	dl {
		flex: 1;

		dt {
			margin-top: 0.5rem;
		}
	}
	.mobile-inline-block {
		@media #{map-get($display-breakpoints, 'xs-only')} {
			display: inline-block;
		}
	}
	.label-width {
		width: 25px;
	}
}

.total {
	dd {
		text-align: right;
	}

	dl {
		display: grid;
		grid-template-columns: auto auto;
		gap: 0.25rem;
		align-items: center;
	}

	@media #{map-get($display-breakpoints, 'xs-only')} {
		dt {
			margin-top: 0.5rem;
		}
	}
}

/* Similar styling to v-subheader */
dt,
.text-faded {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.54);
}
</style>
